/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-08 15:22:33
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 18:29:33
 */
import { useEffect, useState } from "react";
import { ProTable } from "@ant-design/pro-components";
import { Button, message, Modal } from "antd";
import { getAddTeamMember, getClientList, getTeamMemberList, removeTeamMember } from "@/api/modules/team";
import "./index.less";
import InviteTeamMember from "./components/InviteTeamMembers";
import InviteTeamClient from "./components/InviteTeamCLient";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@/components/user/avatar";
import pendingAvatar from "@/assets/icons/team/待邀请头像@2x.png";
import teamIcon from "@/assets/icons/team/团队@2x.png";
import editIcon from "@/assets/icons/team/编辑@2x.png";
import ownerIcon from "@/assets/icons/team/owner@2x.png";
import memberIcon from "@/assets/icons/team/member@2x.png";

import EditTeamModal from "@/pages/Team/components/EditTeamName";
import { useTranslation } from "react-i18next";
import { setCurrentUser } from "@/redux/modules/global/action";

import { getCurrentUser } from "@/api/modules/user";

const Team = () => {
	const { t } = useTranslation();

	const { currentUser } = useSelector(state => state.global);
	const [activeKey, setActiveKey] = useState("team");

	return (
		<div className="settings_container">
			<div className="settings_content">
				<span className="settings_title">{t("teamSettings.title")}</span>

				<TeamTabs />
				{/*<Tabs*/}
				{/*	className="settings_tabs"*/}
				{/*	items={[*/}
				{/*		{*/}
				{/*			label: <Label*/}
				{/*				icon={activeKey === "team" ? tabTeamActive : tabTeam}*/}
				{/*				text={t("teamSettings.tab1")}*/}
				{/*			/>,*/}
				{/*			key: "team",*/}
				{/*			children: <TeamTabs/>*/}
				{/*		},*/}
				{/*		{*/}
				{/*			label: <Label*/}
				{/*				icon={activeKey === "clients" ? tabClientsActive : tabClients}*/}
				{/*				text={t("teamSettings.tab2")}*/}
				{/*			/>,*/}
				{/*			key: "clients",*/}
				{/*			children: <ClientTabs/>*/}
				{/*		}*/}
				{/*	]}*/}
				{/*	onChange={(key) => setActiveKey(key)}*/}
				{/*/>*/}
			</div>
		</div>
	);
};

const TeamTabs = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { currentUser, currentTeam, language } = useSelector(state => state.global);

	const [isOwner, setIsOwner] = useState(false);
	const [memberList, setMemberList] = useState();
	const [showEditTeamModal, setShowEditTeamModal] = useState(false);
	const [showInviteMemberModal, setShowInviteMemberModal] = useState(false);

	useEffect(() => {
		getCurrentUser().then(res => {
			dispatch(setCurrentUser(res.data));
		});
	}, []);
	useEffect(() => {
		setIsOwner(currentUser?.id === currentTeam?.ownerId);
	}, [currentUser, currentTeam]);

	useEffect(() => {
		requestTeamMemberList();
	}, [currentTeam]);

	const handleResentInvitation = record => {
		Modal.confirm({
			title: t("teamSettings.team.resent.modal.title"),
			content: t("teamSettings.team.resent.modal.text", { email: record.email }),
			closable: true,
			maskClosable: true,
			width: 720,
			onOk() {
				const params = {
					email: record.email,
					language: language
				};

				getAddTeamMember(params).then(res => {
					console.log(res);
					if (res.code === 200) {
						message.success(t("teamSettings.team.invite.success.message"));
					}
				});
			}
		});
	};

	const requestTeamMemberList = () => {
		getTeamMemberList().then(res => {
			if (res.code === 200) {
				const memberList = res.data.list.map(item => {
					return {
						key: item.id,
						...item
					};
				});
				setMemberList(memberList);
			}
		});
	};

	const deleteMember = record => {
		Modal.confirm({
			title: t("teamSettings.team.remove.modal.title", { email: record.email }),
			content: t("teamSettings.team.remove.modal.text", { email: record.email }),
			okText: t("teamSettings.team.remove.modal.ok"),
			closable: true,
			maskClosable: true,
			width: 720,
			okType: "danger",
			onOk() {
				const params = {
					id: record.id
				};

				removeTeamMember(params).then(res => {
					if (res.code === 200) {
						message.success("Delete success!");
						const newMemberList = memberList.filter(item => item.id !== record.id);
						setMemberList(newMemberList);
					} else {
						message.error(res.message);
					}
				});
			}
		});
	};

	const columns = [
		{
			key: "user",
			width: "40%",
			render: record => {
				return (
					<div style={{ display: "flex", alignItems: "center" }}>
						<span style={{ marginRight: "0.5rem" }}>
							{record.acceptInvitation === "0" && <img src={pendingAvatar} style={{ width: "2rem", height: "2rem" }} />}
							{record.acceptInvitation === "1" && <Avatar username={record.name} size="2rem" fontSize="0.75rem" />}
						</span>
						<span style={{ fontSize: "0.875rem" }}>{record.email}</span>
						{currentUser.nickname === record.name && (
							<span
								style={{
									width: "2rem",
									height: "1rem",
									marginLeft: "10px",
									background: "#FFAF41",
									textAlign: "center",
									fontSize: "0.75rem",
									lineHeight: "1rem",
									color: "#FFF",
									borderRadius: "2px"
								}}
							>
								You
							</span>
						)}
						{record.acceptInvitation === "0" && (
							<span
								style={{
									marginLeft: "0.5rem",
									fontSize: "0.875rem",
									lineHeight: "1rem",
									color: "#787878"
								}}
							>
								{t("teamSettings.team.invite.pending.text")}
							</span>
						)}
					</div>
				);
			}
		},
		{
			key: "role",
			width: "30%",
			render: record => {
				return (
					<div style={{ display: "flex", alignItems: "center" }}>
						<img src={record.identity === "1" ? ownerIcon : memberIcon} style={{ width: "1rem", marginRight: "0.5rem" }} />
						<span style={{ fontSize: "0.875rem" }}>{record.identity === "1" ? "Owner" : "Member"}</span>
					</div>
				);
			}
		},
		{
			key: "action",
			render: record => {
				return (
					<div style={{ textAlign: "right", marginRight: "1rem" }}>
						{isOwner && record.acceptInvitation === "0" && (
							<Button onClick={() => handleResentInvitation(record)} style={{ color: "#565BDD", border: "0" }}>
								{t("teamSettings.team.table.action.resent")}
							</Button>
						)}
						{isOwner && record.identity === "2" && (
							<Button onClick={() => deleteMember(record)} style={{ color: "#565BDD", border: "0" }}>
								{t("teamSettings.team.table.action.remove")}
							</Button>
						)}
					</div>
				);
			}
		}
	];
	return (
		<div>
			<div className="team_header">
				<div className="team_header_left">
					<img src={teamIcon} alt="" className="team_icon" />
					<span style={{ display: "inline-flex", alignItems: "flex-end" }}>
						<span className="team_name">{currentTeam?.name}</span>
						{isOwner && (
							<span onClick={() => setShowEditTeamModal(true)}>
								<img className="edit_icon" src={editIcon} alt="" />
							</span>
						)}
					</span>
				</div>
				<div className="team_header_right">
					{isOwner && (
						<Button className="invite_button" onClick={() => setShowInviteMemberModal(true)}>
							{t("teamSettings.team.invite.button")}
						</Button>
					)}
				</div>
			</div>
			{isOwner && <div className="teamTabTip">{t("teamSettings.team.tip")}</div>}

			<div className="team_table">
				<div className="team_table_title">{`${t("teamSettings.team.table.title")} (${memberList?.length}/${
					currentUser.currentPlan?.teamSizeLimit || 1
				})`}</div>

				<ProTable
					showHeader={false}
					search={false}
					pagination={false}
					toolBarRender={false}
					columns={columns}
					dataSource={memberList}
				/>
			</div>
			<EditTeamModal
				open={showEditTeamModal}
				onClose={() => {
					setShowEditTeamModal(false);
				}}
				currentTeam={currentTeam}
			/>
			<InviteTeamMember
				open={showInviteMemberModal}
				onClose={() => {
					setShowInviteMemberModal(false);
				}}
				onOkCallBack={() => {
					requestTeamMemberList();
				}}
			/>
		</div>
	);
};

const ClientTabs = () => {
	const { t } = useTranslation();
	const [showInviteClientModal, setSHowInviteClientModal] = useState(false);

	const columns = [
		{
			key: "user",
			width: "40%",
			render: record => {
				return (
					<div style={{ display: "flex", alignItems: "center" }}>
						<span style={{ marginRight: "0.5rem" }}>
							<Avatar username={record.name} size="2rem" fontSize="0.75rem" />
						</span>
						<span style={{ fontSize: "0.875rem" }}>{record.email}</span>
					</div>
				);
			}
		},
		{
			key: "action",
			render: record => {
				return (
					<div style={{ textAlign: "right" }}>
						{record.identity === "1" ? null : (
							<Button onClick={() => deleteMember(record)} style={{ color: "#565BDD", border: "0" }}>
								{t("teamSettings.client.table.action.remove")}
							</Button>
						)}
					</div>
				);
			}
		}
	];
	return (
		<div>
			<div className="client_header">
				<div className="client_header_left">{t("teamSettings.client.tip")}</div>
				<div className="client_header_right">
					<Button className="invite_button" onClick={() => setSHowInviteClientModal(true)}>
						{t("teamSettings.client.invite.button")}
					</Button>
				</div>
			</div>

			<div className="team_table">
				<div className="team_table_title">{t("teamSettings.client.table.title")}</div>
				<ProTable
					showHeader={false}
					search={false}
					pagination={false}
					toolBarRender={false}
					columns={columns}
					request={async params => {
						const res = await getClientList(params);
						if (res.code === 200) {
							return {
								data: res.data.list,
								success: true
							};
						}
					}}
				/>
			</div>
			<InviteTeamClient open={showInviteClientModal} onClose={() => setSHowInviteClientModal(false)} />
		</div>
	);
};
export default Team;
